import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";
import sections from "fantastic/lib/sections";

export default id => (dispatch, getState) => {
  const node = sections.byId(id, getState().sections);
  if(!node.meta.removable) return;
  dispatch({ type: "SECTIONS/REMOVE", payload: { id } });
  dispatch({ type: "SELECTED_NODE/SET", payload: null });
  debouncedSaveTemplate(dispatch, getState);
};
